import { useTranslation } from "react-i18next";
import React from "react";
import { IFormValues } from "../types";
import { FormTextField } from "../../../components/fields";

const  DisableFormTextField = (props: {name: any, label: string}) => {
    const { t } = useTranslation('booking');
    return (
        <FormTextField<IFormValues>
            name={props.name}
            label={t(`${props.label}`)}
            InputProps={{
                readOnly: true
            }}
            InputLabelProps={{
                shrink: true
            }}
            disabled={true}
        />
    )
}

export default DisableFormTextField;
